// extracted by mini-css-extract-plugin
export default {"container":"iF-z","dimension":"jF-z","dimensionLabels":"kF-z"};